<template>
  <div class="delivery-and-payment">
    <h1 class="delivery-and-payment__title">{{ $t('support_main_title') }}</h1>
    <div class="delivery-and-payment__content">
      <div class="delivery-and-payment__nav">
        <div class="delivery-and-payment__nav-wrapper">
          <a href="#shipping"
             class="delivery-and-payment__nav-item"
             :class="{'delivery-and-payment__nav-item--active': activeTab === 'shipping'}"
             @click="setActiveTab($event,'shipping')">{{$t('delivery_tab')}}</a>
          <a href="#payment"
             class="delivery-and-payment__nav-item"
             :class="{'delivery-and-payment__nav-item--active': activeTab === 'payment'}"
             @click="setActiveTab($event,'payment')">{{$t('payment_tab')}}</a>
          <a href="#return-goods"
             class="delivery-and-payment__nav-item"
             :class="{'delivery-and-payment__nav-item--active': activeTab === 'return-goods'}"
             @click="setActiveTab($event,'return-goods')">{{$t('return_tab')}}</a>
        </div>
      </div>
      <div class="delivery-and-payment__tabs">
        <section data-tab="shipping" ref="shipping">
          <h2 class="delivery-and-payment__tabs-title">{{$t('delivery_tab')}}</h2>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[0]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 0)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 0)">
              <svg width="26"
                   height="17"
                   viewBox="0 0 26 17"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5692 10.7065V10.6374C13.6382 10.2231 13.6382 9.80876 13.6382 9.46348C13.6382 8.0133 13.1548 5.73446 11.7047 4.31881C10.0473 2.73053 8.21734 2.14355 6.14566 2.14355H5.04077L5.83491 2.9377L13.5692 10.7065Z" fill="#FF2F00"/>
                <path d="M9.73688 11.6029C8.90821 12.8114 7.31992 13.6056 5.86975 13.6056C5.07561 13.6056 4.35052 13.6056 3.69449 13.6056V5.56056L0 1.83154V16.9548H3.03846H3.72902H6.00786C8.32123 16.9548 10.0476 16.4369 11.774 14.814C11.9812 14.6069 12.1538 14.3997 12.3265 14.158L9.73688 11.6029Z" fill="#FF2F00"/>
                <path d="M26.0001 0L21.1316 4.86844L16.2632 0V9.56424H18.8873V6.04239L21.1662 8.32123L23.4105 6.07692V9.56424H26.0001V0Z" fill="#141419"/>
              </svg>
              <h2 class="info-tabs-item__title-name">{{$t('support_pickup')}}</h2>
              <div class="info-tabs-item__break"></div>
              <span class="info-tabs-item__title-price-free info-tabs-item__title-price-free--no-margin">{{$t('support_free')}}</span>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[0]}">
                <p class="info-tabs-item__bigger-fz">{{$t('delivery_text_1')}}</p>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--demi" v-html="$t('delivery_text_2')"></p>
                <h3>{{$t('delivery_text_3')}}</h3>
                <ul>
                  <li>{{$t('delivery_text_4')}}</li>
                  <li>{{$t('dm_consult')}}</li>
                  <li>{{$t('delivery_text_5')}}</li>
                  <li>{{$t('delivery_text_6')}}</li>
                  <li>{{$t('delivery_text_7')}}</li>
                </ul>
                <p>{{$t('delivery_text_8')}}</p>
                <a href="https://dnipro-m.ua/shops/" class="link link--pseudo info-tabs-item__link-offset info-tabs-item__link-offset--small">{{$t('see_shops')}}</a>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[1]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 1)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 1)">
              <svg width="26"
                   height="17"
                   viewBox="0 0 26 17"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5692 10.7065V10.6374C13.6382 10.2231 13.6382 9.80876 13.6382 9.46348C13.6382 8.0133 13.1548 5.73446 11.7047 4.31881C10.0473 2.73053 8.21734 2.14355 6.14566 2.14355H5.04077L5.83491 2.9377L13.5692 10.7065Z" fill="#FF2F00"/>
                <path d="M9.73688 11.6029C8.90821 12.8114 7.31992 13.6056 5.86975 13.6056C5.07561 13.6056 4.35052 13.6056 3.69449 13.6056V5.56056L0 1.83154V16.9548H3.03846H3.72902H6.00786C8.32123 16.9548 10.0476 16.4369 11.774 14.814C11.9812 14.6069 12.1538 14.3997 12.3265 14.158L9.73688 11.6029Z" fill="#FF2F00"/>
                <path d="M26.0001 0L21.1316 4.86844L16.2632 0V9.56424H18.8873V6.04239L21.1662 8.32123L23.4105 6.07692V9.56424H26.0001V0Z" fill="#141419"/>
              </svg>
              <h2 class="info-tabs-item__title-name">{{$t('delivery_text_9')}}</h2>
              <div class="info-tabs-item__break"></div>
              <span class="info-tabs-item__title-price-free info-tabs-item__title-price-free--no-margin">{{$t('support_free')}}</span>
              <b class="fz-small" v-html="$t('from_3_hours')"></b>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[1]}">
                <ul>
                  <li>
                    <p>{{$t('delivery_text_11')}}</p>
                    <p class="info-tabs-item__subtitle">{{$t('delivery_text_12')}}</p>
                  </li>
                  <li>{{$t('delivery_text_13')}}</li>
                </ul>
                <p>{{$t('delivery_text_14')}}</p>
                <p class="info-tabs-item__subtitle">{{$t('delivery_text_15')}}</p>
                <p class="info-tabs-item__offset-top-text">{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('delivery_text_16')}}</li>
                  <li>{{$t('delivery_text_17')}}</li>
                  <li>{{$t('delivery_text_18')}}</li>
                </ul>
                <p class="info-tabs-item__subtitle">{{$t('delivery_text_18_1')}}</p>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[2]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 2)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 2)">
              <svg width="21"
                   height="20"
                   viewBox="0 0 21 20"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M16.827 5.92177C16.8905 5.90249 16.9741 5.94105 17.0577 6.04707C17.0577 6.04707 17.0577 6.04707 20.8345 9.60054C21.0551 9.81259 21.0551 10.1339 20.8345 10.2913C20.8345 10.2913 20.8345 10.2913 17.0577 13.8994C16.9741 14.0054 16.8905 14.0311 16.827 13.999C16.7635 13.9669 16.7234 13.8737 16.7234 13.7388V6.1531C16.7234 6.02137 16.7635 5.94105 16.827 5.92177Z"
                      fill="#ED1C24"/>
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M10.3664 0H10.6338L10.8911 0.102813C10.8911 0.102813 10.8911 0.102813 14.7783 3.81693C14.9454 4.02898 14.8886 4.18963 14.6112 4.18963C14.6112 4.18963 14.6112 4.18963 13.0001 4.18963C12.7227 4.18963 12.5021 4.40168 12.5021 4.66835C12.5021 4.66835 12.5021 4.66835 12.5021 7.42502C12.5021 7.69169 12.2782 7.90374 11.944 7.90374C11.944 7.90374 11.944 7.90374 9.11299 7.90374C8.83557 7.90374 8.61164 7.69169 8.61164 7.42502C8.61164 7.42502 8.61164 7.42502 8.61164 4.66835C8.61164 4.40168 8.39104 4.18963 8.11028 4.18963H6.38897C6.11156 4.18963 6.05474 4.02898 6.22185 3.81693C6.22185 3.81693 6.22185 3.81693 10.1124 0.102813L10.3664 0Z"
                      fill="#ED1C24"/>
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M4.27654 5.84204C4.34673 5.87417 4.39018 5.96734 4.39018 6.10229V13.8454C4.39018 13.9803 4.34673 14.0606 4.27654 14.0864C4.2097 14.1121 4.11277 14.0864 3.99913 14.006C3.99913 14.006 3.99913 14.006 0.165447 10.2919C-0.0551489 10.1345 -0.0551489 9.81319 0.165447 9.60114C0.165447 9.60114 0.165447 9.60114 3.99913 5.94164C4.11277 5.83562 4.2097 5.80991 4.27654 5.84204Z"
                      fill="#ED1C24"/>
                <path fill-rule="evenodd"
                      clip-rule="evenodd"
                      d="M9.11295 11.9346C9.11295 11.9346 9.11295 11.9346 11.9439 11.9346C12.2782 11.9346 12.5021 12.1466 12.5021 12.4133C12.5021 12.4133 12.5021 12.4133 12.5021 15.3306C12.5021 15.6487 12.7227 15.8607 13.0001 15.8607H14.5008C14.7782 15.8607 14.8885 16.0182 14.6679 16.1788C14.6679 16.1788 14.6679 16.1788 10.8911 19.8383C10.7774 19.9443 10.6404 19.999 10.5 19.999C10.363 19.999 10.2226 19.9443 10.1123 19.8383C10.1123 19.8383 10.1123 19.8383 6.33546 16.1788C6.11152 16.0182 6.22182 15.8607 6.49923 15.8607C6.49923 15.8607 6.49923 15.8607 8.11025 15.8607C8.391 15.8607 8.6116 15.6487 8.6116 15.3306C8.6116 15.3306 8.6116 15.3306 8.6116 12.4133C8.6116 12.1466 8.83554 11.9346 9.11295 11.9346Z"
                      fill="#ED1C24"/>
              </svg>
              <h2 class="info-tabs-item__title-name">{{$t('delivery_text_20')}}</h2>
              <div class="info-tabs-item__break"></div>
              <div class="info-tabs-item__title-price-block">
                <p v-html="$t('delivery_text_21')"></p>
                <p v-html="$t('delivery_text_21_2')"></p>
              </div>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[2]}">
                <ul>
                  <li>
                    <p>{{$t('delivery_text_26_1')}}</p>
                    <p class="info-tabs-item__subtitle">{{$t('delivery_text_26_2')}}</p>
                  </li>
                  <li>{{$t('delivery_text_26_3')}}</li>
                </ul>
                <p>{{$t('delivery_text_24')}}</p>
                <p class="info-tabs-item__offset-top-text" v-html="$t('delivery_text_25')"></p>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--small">{{$t('delivery_text_26')}}</p>
                <p class="info-tabs-item__offset-top-text">{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('delivery_text_27')}}</li>
                  <li>{{$t('delivery_text_28')}}</li>
                  <li>{{$t('delivery_text_29')}}</li>
                  <li>{{$t('delivery_text_30')}}</li>
                </ul>
                <a href="https://novaposhta.ua/ru/tracking" target="_blank" class="link link--pseudo">{{$t('detect_delivery')}}</a>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[3]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 3)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 3)">
              <svg width="18"
                   height="25"
                   viewBox="0 0 18 25"
                   fill="none"
                   xmlns="http://www.w3.org/2000/svg">
                <path d="M16.2868 13.6744L8.0709 11.8966C5.6236 11.3464 4.09404 9.01831 4.66216 6.64794C5.23029 4.27757 7.63389 2.79609 10.0812 3.34635C12.5285 3.89662 14.0581 6.22466 13.4899 8.59503C13.2277 9.78021 12.4848 10.7538 11.4796 11.3464C11.4359 11.3464 11.4359 11.3887 11.4359 11.431C11.4359 11.4733 11.4796 11.5157 11.5233 11.558L15.1943 12.3622C15.2817 12.3622 15.3691 12.3622 15.4128 12.2776C16.4179 11.0077 17.0298 9.39926 17.0298 7.66381C17.0298 3.55799 13.7084 0.214077 9.55677 0.00243721C9.51306 0.00243721 9.29455 0.00243721 9.20715 0.00243721C7.37168 -0.0398908 5.4925 0.468046 3.87553 1.6109C-0.232437 4.40455 -1.23758 9.86487 1.64674 13.8437L8.94494 23.9178C8.98864 23.9601 9.03234 24.0024 9.07605 24.0024C9.11975 24.0024 9.16345 23.9601 9.20715 23.9178L16.3742 14.013C16.3742 13.9707 16.4179 13.9707 16.4179 13.9284C16.4179 13.7591 16.3305 13.7167 16.2868 13.6744Z" fill="#FFC629"/>
              </svg>
              <h2 class="info-tabs-item__title-name">{{$t('delivery_text_31')}}</h2>
              <div class="info-tabs-item__break"></div>
              <span class="info-tabs-item__subtitle-wrapper" v-html="$t('delivery_text_32')"></span>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[3]}">
                <ul>
                  <li>{{$t('delivery_text_32_1')}}</li>
                </ul>
                <p>{{$t('delivery_text_34')}}</p>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--small">{{$t('delivery_text_35')}}</p>
                <p class="info-tabs-item__offset-top-text">{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('delivery_text_36')}}</li>
                  <li>{{$t('delivery_text_37')}}</li>
                  <li>{{$t('delivery_text_38')}}</li>
                </ul>
                <a href="https://track.ukrposhta.ua/tracking_UA.html" target="_blank" class="link link--pseudo">{{$t('detect_delivery')}}</a>
              </div>
            </div>
          </div>
        </section>
        <section data-tab="payment" ref="payment">
          <h2 class="delivery-and-payment__tabs-title">{{$t('payment_tab')}}</h2>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[10]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 10)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 10)">
              <h2 class="info-tabs-item__title-name">{{$t('payment_text_1')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[10]}">
                <p>{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('payment_text_3')}}</li>
                  <li>{{$t('payment_text_4')}}</li>
                  <li>
                    <p>{{$t('payment_text_5_2')}}</p>
                    <p class="info-tabs-item__subtitle">{{$t('payment_text_6')}}</p>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[4]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open"  @click="setOpenedItems($event, 4)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 4)">
              <h2 class="info-tabs-item__title-name">{{$t('payment_text_7')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[4]}">
                <b>{{$t('payment_text_8')}}</b>
                <ul>
                  <li>{{$t('payment_text_9')}}</li>
                  <li>{{$t('payment_text_10')}}</li>
                  <li>
                    <p>{{$t('payment_text_11')}}</p>
                    <p class="info-tabs-item__subtitle">{{$t('payment_text_12')}}</p>
                  </li>
                  <li>
                    <p>{{$t('payment_text_13')}}</p>
                    <p class="info-tabs-item__subtitle">{{$t('payment_text_14')}}</p>
                  </li>
                </ul>
                <p class="info-tabs-item__offset-top-text">{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('payment_text_15')}}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[11]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 11)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 11)">
              <h2 class="info-tabs-item__title-name">{{$t('payment_text_16')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[11]}">
                <b>{{$t('payment_text_17')}}</b>
                <ul>
                  <li>
                    <p>{{$t('payment_text_18')}}</p>
                    <p class="info-tabs-item__subtitle">{{$t('payment_text_19')}}</p>
                  </li>
                  <li>{{$t('payment_text_20')}}</li>
                </ul>
                <p class="info-tabs-item__offset-top-text">{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('payment_text_21')}}</li>
                  <li>{{$t('payment_text_22')}}</li>
                  <li>{{$t('payment_text_23')}}</li>
                  <li>{{$t('payment_text_24')}}</li>
                </ul>
                <a href="https://dnipro-m.ua/news/oplata-chastyami-instrument-i-oborudovanie/" class="link link--pseudo">{{$t('payment_text_25')}}</a>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[5]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 5)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 5)">
              <h2 class="info-tabs-item__title-name">{{$t('payment_text_26')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[5]}">
                <ul>
                  <li>
                    <p v-html="$t('payment_text_27')"></p>
                    <p class="info-tabs-item__subtitle">{{$t('payment_text_28')}}</p>
                  </li>
                  <li>{{$t('payment_text_29')}}</li>
                </ul>
                <b class="info-tabs-item__offset-top-text">{{$t('payment_text_30')}}</b>
                <ul>
                  <li>{{$t('payment_text_31')}}</li>
                  <li>{{$t('payment_text_32')}}</li>
                </ul>
                <p class="info-tabs-item__offset-top-text">{{$t('payment_text_33')}}</p>
                <p class="info-tabs-item__offset-top-text">{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('payment_text_34')}}</li>
                  <li>{{$t('payment_text_35')}}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[12]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 12)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 12)">
              <h2 class="info-tabs-item__title-name">{{$t('payment_text_36')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[12]}">
                <p>{{$t('payment_text_37')}}</p>
                <p class="info-tabs-item__offset-top-text info-tabs-item__bigger-fz">{{$t('payment_text_38')}}</p>
                <p class="fz-small info-tabs-item__offset-top-text--small">{{$t('payment_text_39')}}</p>
                <p class="info-tabs-item__offset-top-text">{{$t('payment_text_48')}}</p>
                <p class="info-tabs-item__offset-top-text">{{$t('payment_text_40')}}</p>
                <ul>
                  <li>{{$t('payment_text_41')}}</li>
                  <li>{{$t('payment_text_42')}}</li>
                  <li>{{$t('payment_text_43')}}</li>
                  <li>{{$t('payment_text_44')}}</li>
                  <li>{{$t('payment_text_45')}}</li>
                </ul>
                <p class="info-tabs-item__offset-top-text">{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('payment_text_46')}}</li>
                  <li>{{$t('payment_text_47')}}</li>
                  <li>{{$t('payment_text_50')}}</li>
                  <li>{{$t('payment_text_51')}}</li>
                </ul>
              </div>
            </div>
          </div>
        </section>
        <section data-tab="return-goods" ref="return-goods">
          <h2 class="delivery-and-payment__tabs-title">{{$t('return_tab')}}</h2>
          <div class="info-tabs-item-wrapper" v-if="$t('return_text_0')" :class="{'info-tabs-item-wrapper--opened': openedItems[6]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 6)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 6)">
              <h2 class="info-tabs-item__title-name">{{$t('return_text_0')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[6]}">
                <p v-html="$t('return_text_1')"></p>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_2')}}</b>
                <ul>
                  <li>
                    <p>{{$t('return_text_3')}}</p>
                    <p class="info-tabs-item__subtitle">{{$t('return_text_4')}}</p>
                  </li>
                  <li>{{$t('return_text_5')}}</li>
                  <li>{{$t('return_text_6')}}</li>
                  <li>{{$t('return_text_7')}}</li>
                  <li>{{$t('return_text_8')}}</li>
                </ul>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[7]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 7)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 7)">
              <h2 class="info-tabs-item__title-name">{{$t('return_text_79')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[7]}">
                <p v-html="$t('return_text_9')"></p>
                <ul>
                  <li>{{$t('return_text_77')}}</li>
                  <li>{{$t('return_text_78')}}</li>
                </ul>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_2')}}</b>
                <ul>
                  <li>
                    <p>{{$t('return_text_3')}}</p>
                    <p class="info-tabs-item__subtitle">{{$t('return_text_4')}}</p>
                  </li>
                  <li>{{$t('return_text_11')}}</li>
                  <li>{{$t('return_text_12')}}</li>
                  <li>{{$t('return_text_13')}}</li>
                  <li>{{$t('return_text_14')}}</li>
                </ul>
                <p class="info-tabs-item__offset-top-text">{{$t('support_note')}}</p>
                <ul>
                  <li>{{$t('return_text_15')}}</li>
                </ul>
                <p class="info-tabs-item__offset-top-text" v-html="$t('return_text_16')"></p>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[8]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 8)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 8)">
              <h2 class="info-tabs-item__title-name">{{$t('return_text_17_2')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[8]}">
                <p v-html="$t('return_text_17')"></p>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_18')}}</b>
                <ul>
                  <li>{{$t('return_text_19')}}</li>
                  <li>{{$t('return_text_20')}}</li>
                  <li>{{$t('return_text_21')}}</li>
                  <li>{{$t('return_text_22')}}</li>
                </ul>
                <b class="info-tabs-item__offset-top-text--big info-tabs-item__bigger-fz">{{$t('return_text_26')}}</b>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_28')}}</b>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest">{{$t('return_text_29')}}</p>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_30')}}</b>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest">{{$t('return_text_31')}}</p>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_32')}}</b>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest">{{$t('return_text_33')}}</p>
                <ol class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest">
                  <li class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest" v-html="$t('return_text_34')"></li>
                  <li class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest" v-html="$t('return_text_35')"></li>
                  <li class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest">{{$t('return_text_36')}}</li>
                </ol>
              </div>
            </div>
          </div>
          <div class="info-tabs-item-wrapper" :class="{'info-tabs-item-wrapper--opened': openedItems[9]}">
            <button type="button" class="info-tabs-item-wrapper__toggle-open" @click="setOpenedItems($event, 9)"></button>
            <div class="info-tabs-item__title" @click="setOpenedItems($event, 9)">
              <h2 class="info-tabs-item__title-name">{{$t('return_text_37')}}</h2>
            </div>
            <div class="info-tabs-item">
              <div class="info-tabs-item__content" :class="{'info-tabs-item__content--opened': openedItems[9]}">
                <blockquote>
                  <p class="info-tabs-item__bigger-fz">{{$t('return_text_38')}}</p>
                </blockquote>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_39')}}</b>
                <p class="info-tabs-item__offset-top-text--small subtitle-color">{{$t('return_text_40')}}</p>
                <p>{{$t('return_text_41')}}</p>
                <p class="info-tabs-item__offset-top-text--small subtitle-color">{{$t('return_text_42')}}</p>
                <p>{{$t('return_text_43')}}</p>
                <p class="info-tabs-item__offset-top-text--small subtitle-color">{{$t('return_text_44')}}</p>
                <p>{{$t('return_text_45')}}</p>
                <p class="info-tabs-item__offset-top-text--small subtitle-color">{{$t('return_text_46')}}</p>
                <p>{{$t('return_text_47')}}</p>
                <p class="info-tabs-item__offset-top-text--small subtitle-color">{{$t('return_text_48')}}</p>
                <p>{{$t('return_text_49')}}</p>
                <p class="info-tabs-item__offset-top-text--small subtitle-color">{{$t('return_text_50')}}</p>
                <p>{{$t('return_text_51')}}</p>
                <p class="info-tabs-item__offset-top-text--small subtitle-color">{{$t('return_text_52')}}</p>
                <p>{{$t('return_text_53')}}</p>
                <b class="info-tabs-item__offset-top-text--big info-tabs-item__bigger-fz">{{$t('return_text_55')}}</b>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_30')}}</b>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest" v-html="$t('return_text_57')"></p>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--small" v-html="$t('return_text_58')"></p>
                <b class="info-tabs-item__offset-top-text">{{$t('return_text_32')}}</b>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest">{{$t('return_text_33')}}</p>
                <ol>
                  <li class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest" v-html="$t('return_text_34')"></li>
                  <li class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest" v-html="$t('return_text_61')"></li>
                  <li class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--smallest">{{$t('return_text_62')}}</li>
                </ol>
                <p class="info-tabs-item__offset-top-text info-tabs-item__offset-top-text--small">{{$t('return_text_63')}}</p>
              </div>
            </div>
          </div>
        </section>
      </div>
    </div>
  </div>
</template>

<script>
import router from '@/router'

export default {
  name: 'DeliveryAndPayment',
  data () {
    return {
      openedItems: {},
      activeTab: 'shipping'
    }
  },
  methods: {
    setOpenedItems (e, idx) {
      e.stopPropagation()
      const clone = { ...this.openedItems }
      if (!clone[idx.toString()]) clone[idx] = true
      else delete clone[idx]

      this.openedItems = clone
    },
    setActiveTab (e, tab) {
      if (e) e.preventDefault()
      const isAdaptive = !window.matchMedia(`(min-width: 1024px)`).matches
      const additional = isAdaptive ? 140 : 100

      if (isAdaptive) {
        router.push({ hash: tab }).catch(() => {})
      } else {
        router.replace({ hash: tab }).catch(() => {})
      }

      this.activeTab = tab
      this.$refs[tab].scrollIntoView({ block: 'start' })
      window.scrollTo(0, window.scrollY - additional)
    },
    handleScroll () {
      const navbar = document.querySelector('.delivery-and-payment__nav-wrapper')
      if (window.innerWidth > 1023) {
        // if (window.scrollY - navbar.offsetTop > 220) {
        //   navbar.style.paddingTop = '15px'
        // } else {
        //   navbar.style.paddingTop = 0
        // }
      } else {
        if (window.scrollY > 200) {
          navbar.style.boxShadow = '0 2px 4px rgba(0,0,0,.1)'
        } else {
          navbar.style.boxShadow = 'none'
        }
      }
    }
  },
  mounted () {
    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'
    }
    window.addEventListener('scroll', () => {
      const sections = document.querySelectorAll('.delivery-and-payment__tabs section')
      sections.forEach((el) => {
        if (el.offsetTop - window.scrollY < 200) {
          this.activeTab = el.dataset.tab
        }
      })
      this.handleScroll()
    })
    const hash = window.location.hash.replace('#', '')

    window.addEventListener('load', () => {
      setTimeout(() => {
        this.setActiveTab(null, hash)
        this.handleScroll()
      }, 1000)
    })
    window.addEventListener('popstate', () => {
      if (window.location.href.includes('/dostavka-i-oplata/')) {
        this.setActiveTab(null, window.location.hash.replace('#', ''))
      }
    })
  }
}
</script>
<style lang="sass">

.delivery-and-payment
  h2, h1, h3, span, p, a, ul, li, ol
    margin: 0
    padding: 0

  p
    line-height: 24px

  b
    font-weight: 500

  h3
    margin-top: 30px
    color: #444444
    font-weight: 500
    font-size: 16px

  a
    line-height: 24px

  ul
    list-style: none
    padding-left: 25px

    &:not(:last-child)
      margin-bottom: 30px

    &:not(:first-child)
      margin-top: 15px

    & > li
      position: relative

      &:not(:last-child)
        margin-bottom: 15px

      &:before
        content: ''
        position: absolute
        width: 6px
        height: 6px
        border-radius: 50%
        background-color: $nd-border-color
        left: -25px
        top: 7px

  .info-tabs-item__offset-top-text, .info-tabs-item__offset-top-text--small, .info-tabs-item__offset-top-text--big, .info-tabs-item__offset-top-text--smallest
    display: block

  .info-tabs-item__offset-top-text
    margin-top: 30px

    &--small
      margin-top: 15px

    &--big
      margin-top: 50px

    &--smallest
      margin-top: 5px

    &--demi
      margin-top: 10px

  .delivery-and-payment__title
    margin-left: 15px
    font-weight: 500

    +mmin($tablet--hor)
      margin-left: 0

  .delivery-and-payment__content
    display: flex
    flex-direction: column
    justify-content: space-between
    margin-top: 50px

    +mmin($tablet--hor)
      flex-direction: row

  .delivery-and-payment__nav
    position: sticky
    z-index: 1
    top: 49px

    +mmin($tablet--hor)
      position: relative
      max-width: 242px
      width: 20%
      top: 0

  .delivery-and-payment__nav-wrapper
    position: sticky
    top: 80px
    display: flex
    border-top: 1px solid $nd-border-color
    border-bottom: 1px solid $nd-border-color

    +mmin($tablet--hor)
      flex-direction: column
      margin-bottom: 4px
      border: 0
      box-shadow: none

  .delivery-and-payment__tabs
    +mmin($tablet--hor)
      width: 75%

    section
      &:not(:first-child) .delivery-and-payment__tabs-title
        margin-top: 50px

      &:first-child .delivery-and-payment__tabs-title
        margin-top: 20px

        +mmin($tablet--hor)
          margin-top: 0

  .delivery-and-payment__nav-item
    border: 1px solid transparent
    cursor: pointer
    color: $text-color
    display: block
    width: 33.333%
    padding: 23px 0
    text-transform: uppercase
    text-align: center
    background-color: white
    font-size: 14px

    &:not(:last-child)
      border-right: 1px solid $nd-border-color

      +mmin($tablet--hor)
        border-right-color: transparent

    +mmin($tablet--hor)
      padding: 13px 30px
      width: 100%
      text-transform: none
      text-align: left
      margin-bottom: 4px
      border-radius: 3px
      font-size: 16px

    &--active
      background-color: $nd-disabled-background-color
      font-weight: 500

  .delivery-and-payment__nav-item:not(.delivery-and-payment__nav-item--active):hover
    border-color: $nd-border-color

  .delivery-and-payment__tabs-title
    text-transform: uppercase
    color: $nd-label-color
    font-size: 16px
    font-weight: 500
    margin-left: 15px
    position: relative

    +mmin($tablet--hor)
      margin-left: 0

  .info-tabs-item-wrapper
    border-top: 1px solid $nd-border-color
    position: relative
    cursor: pointer

    &:nth-child(2)
      margin-top: 20px

    &:last-child
      border-bottom: 1px solid $nd-border-color

    +mmin($tablet--hor)
      border: 1px solid $nd-border-color
      border-radius: 3px
      margin-top: 20px

    &--opened
      cursor: initial

      .info-tabs-item-wrapper__toggle-open:after
        display: none

  .info-tabs-item-wrapper__toggle-open
    position: absolute
    width: 20px
    height: 20px
    right: 30px
    top: 26px
    padding: 0
    margin: 0
    background-color: transparent
    border: 0

    &:after, &:before
      content: ''
      position: absolute
      background-color: $text-color
      cursor: pointer

    &:hover.info-tabs-item-wrapper__toggle-open:after, &:hover.info-tabs-item-wrapper__toggle-open:before
      background-color: $nd-label-color

    &:after
      width: 2px
      height: 20px
      left: 9px
      top: 0

    &:before
      left: 0
      top: 9px
      height: 2px
      width: 20px

  .info-tabs-item__content
    max-height: 0
    transition: .3s
    overflow: hidden
    padding: 0 15px

    +mmin($tablet--hor)
      padding-left: 40px

    &--opened
      max-height: 2000px
      padding-bottom: 30px
      padding-top: 5px

      +mmin($tablet--hor)
        padding-bottom: 50px

  .info-tabs-item
    max-width: 623px

    +mmin($tablet--hor)
      max-width: 780px

  .info-tabs-item__title
    cursor: pointer
    display: flex
    align-items: center
    flex-wrap: wrap
    padding: 25px 0 25px 15px

    +mmin($tablet--hor)
      flex-wrap: nowrap
      padding-left: 40px
      height: 75px

    .info-tabs-item__subtitle
      margin-top: 0

    svg
      margin-right: 20px
      margin-bottom: 20px

      +mmin($tablet--hor)
        margin-bottom: 0

  .info-tabs-item__title-price-block
    display: flex
    flex-direction: column
    justify-content: center
    line-height: 21px
    width: 100%

    +mmin($tablet--hor)
      transform: translateY(-2px)
      width: auto
      min-width: 400px

      & > p
        width: auto
        min-width: 400px

    p
      line-height: 21px
      width: 100%

      &:first-child
        margin-bottom: 5px

  .info-tabs-item__title-name
    font-size: 18px
    font-weight: 500
    text-transform: uppercase
    margin-right: 30px
    letter-spacing: 0.04em
    line-height: 27px

    &:not(:last-child)
      margin-bottom: 20px

      +mmin($tablet--hor)
        margin-bottom: 0

    +mmin($tablet--hor)
      margin-bottom: 0

  .info-tabs-item__title-price-free
    font-size: 14px
    color: $nd-green-text-color
    font-weight: 500
    margin-left: 5px
    line-height: 21px

    &--no-margin
      margin-left: 0

      +mmin($tablet--hor)
        margin-left: 5px

  .info-tabs-item__bigger-fz
    font-size: 18px

  .info-tabs-item__link-offset
    margin-top: 30px
    display: inline-block

    &--small
      margin-top: 5px

  .fz-small
    font-size: 14px

  .info-tabs-item__subtitle
    font-size: 14px
    color: $placeholder-color
    margin-top: 5px
    display: inline-block
    line-height: 21px

    +mmin($tablet--hor)
      max-width: 650px

  ol
    list-style: decimal
    margin-left: 19px

    & > li
      display: list-item!important

  .subtitle-color
    color: $placeholder-color

  .info-tabs-item__tire
    margin: 0 10px
    color: $placeholder-color

  .info-tabs-item__break
    flex-basis: 100%

    +mmin($tablet--hor)
      flex-basis: 0

  .info-tabs-item__subtitle-wrapper
    width: 100%

    +mmin($tablet--hor)
      width: auto
      min-width: 400px

  blockquote
    font-style: normal
    margin-top: 0
    padding-left: 20px
</style>
